import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormikWrapper,
  FormTextarea as Textarea,
} from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../../../../Button';
import Popup from '../../../../Popup';

type Props = React.ComponentPropsWithRef<typeof Popup> & {
  loading?: boolean;
  onSubmit: (values: any, formProps: any) => void;
};

const InappropriateButtonPopup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    loading = false,
    onSubmit,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const initialValues = { body: '' };

  return (
    <Popup
      title={t('pages.forum.flag_inappropriate_form.title')}
      closeButtonText={t('buttons.close')}
      ref={ref}
      {...restProps}
    >
      <FormikWrapper
        initialValues={initialValues}
        enableReinitialize
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={(values, formProps) => {
          const { setSubmitting } = formProps;
          onSubmit(values, formProps);
          setSubmitting(false);
        }}
      >
        <Textarea
          fieldName="body"
          title={t('pages.forum.flag_inappropriate_form.fields.body.label')}
          value={initialValues.body}
          placeholder={t('pages.forum.flag_inappropriate_form.fields.body.placeholder')}
        />

        <div>
          <Button htmlType="submit" buttonState={loading && 'disabled'}>
            {t('pages.forum.flag_inappropriate_form.submit')}
          </Button>
        </div>
      </FormikWrapper>
    </Popup>
  );
});

export default InappropriateButtonPopup;
